//#frontend/src/Component/layout/StudentHeader.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserCircle, FaSignOutAlt } from 'react-icons/fa';
import '../../assets/styles/global.css'; // ✅ اضافه شدن ایمپورت استایل

const StudentHeader = () => {
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);

    // --- ✅ منطق هوشمند برای نمایش نام ---
    const userFullName = localStorage.getItem('userFullName');
    const userName = localStorage.getItem('userName');
    const displayName = (userFullName && userFullName.trim() !== "") ? userFullName : (userName || 'دانش‌آموز');

    const handleLogout = () => {
        localStorage.clear();
        navigate('/');
    };

    return (
        <header className="header student-header">
            <div className="header-logo">سُهات</div>
            <div className="header-profile">
                <div className="user-menu" onClick={() => setDropdownOpen(!dropdownOpen)}>
                    <span>{displayName} عزیز، خوش آمدید</span>
                    <FaUserCircle className="user-avatar" />
                    {dropdownOpen && (
                        <div className="dropdown-menu">
                            <button onClick={handleLogout}><FaSignOutAlt /><span>خروج از حساب</span></button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default StudentHeader;
